import React from 'react'

const Subscribe = () => {
  return (
    <div>
        <h1>Subscription</h1>
        <p> This page is under construction </p>
    </div>
  )
}

export default Subscribe